import { render, staticRenderFns } from "./ModalReavaliacao.vue?vue&type=template&id=9adfc37c"
import script from "./ModalReavaliacao.vue?vue&type=script&lang=js"
export * from "./ModalReavaliacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports